import axios from 'axios';
import { IChemicalProduct } from '../../../../@types/model/masterData/chemicals/chemicalProduct/chemicalProduct';
import { IChemicalProductUpsert } from '../../../../@types/model/masterData/chemicals/chemicalProduct/chemicalProductUpsert';
import { UpsertTypeEnum } from '../../../../@types/enum/upsertType';

export default class ChemicalProductHttpService {
    public static getList = async (lastSyncedTimeUnix : number, signal ?: AbortSignal) : Promise<Array<IChemicalProduct>> => {
        const result = await axios.get(`${API_URL}/v1/MasterData/ChemicalProduct/GetList`, {
            params: {
                lastSyncedTimeUnix
            },
            signal
        });

        return result.data;
    }

    public static upsert = async (upsert : IChemicalProductUpsert, type : UpsertTypeEnum) : Promise<IChemicalProduct> => {
        const result = await axios.post(`${API_URL}/v1/MasterData/ChemicalProduct/${type}`, upsert);

        return result.data;
    }

    public static delete = async (id : number) : Promise<void> => {
        return await axios.delete(`${API_URL}/v1/MasterData/ChemicalProduct/Delete`, {
            params: { id },
        });
    }
}